import { render } from "./Kavalan.vue?vue&type=template&id=3bfa828d"
import script from "./Kavalan.vue?vue&type=script&lang=js"
export * from "./Kavalan.vue?vue&type=script&lang=js"

import "./Kavalan.vue?vue&type=style&index=0&id=3bfa828d&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__